<template>
  <div>
    <v-container
      class="py-0"
      :class="$store.state.mobile ? 'px-0' : ''"
    >
      <v-row no-gutters>
        <v-col
          v-if="!$store.state.mobile"
          cols="auto"
        >
          <div
            style="width:240px"
          >
            <CategoryList />
            <v-card
              outlined
              tile
              class="mt-3"
            >
              <v-card-title class="black--text headline">
                <template v-if="$store.getters.languageGetter === '1'">
                  البحث الساخن
                </template>
                <template v-else>
                  Hot search
                </template>
              </v-card-title>
              <v-divider />
              <div class="pa-4">
                <router-link
                  v-for="(item,i) in hotSearch.data"
                  :key="i"
                  :to="{name: 'GoodsList', query: {searchStr: item.dnames, p: 1}}"
                  class="me-3 mb-2 d-inline-block hover-decoration-underline"
                  style="word-break:break-word"
                >
                  {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                </router-link>
              </div>
            </v-card>
            <v-card
              outlined
              tile
              class="my-3"
            >
              <v-card-title class="black--text headline">
                <template v-if="$store.getters.languageGetter === '1'">
                  يوصي
                </template>
                <template v-else>
                  Recommend
                </template>
              </v-card-title>
              <v-divider />
              <div class="px-4 py-1">
                <div
                  v-for="(item, i) in recommendGoods"
                  :key="item.id"
                >
                  <router-link
                    v-ripple
                    :to="{name: 'GoodsDetail', params: {id: item.id}}"
                    class="d-flex align-start py-3"
                  >
                    <v-card
                      outlined
                      tile
                    >
                      <v-img
                        :src="item.image"
                        aspect-ratio="1"
                        contain
                        width="77"
                        height="77"
                        class="grey lighten-5"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey"
                            />
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                    <div class="ps-2">
                      <div class="mb-1 line-break-tripple">
                        {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                      </div>
                      <div
                        v-if="$store.state.usedCountry"
                        class="black--text d-flex align-center justify-center"
                      >
                        <span
                          class="text-h4 me-2"
                        >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                        <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
                      </div>
                    </div>
                  </router-link>
                  <v-divider
                    v-if="i < recommendGoods.length - 1"
                  />
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
        <v-col>
          <router-view
            @update:login="$emit('update:login')"
            @update:show-popup="$emit('update:show-popup')"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CategoryList from '@/layout/CategoryList.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'Goods',
  components: {
    CategoryList,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState(['hotSearch']),
    ...mapGetters(['tagGoodsGetter']),
    recommendGoods() {
      return this.tagGoodsGetter('recommends', 8);
    },
  },
  created() {
    this.loadComponentData();
  },
  methods: {
    ...mapActions(['getGoodsByTagAsync']),
    loadComponentData() {
      this.getGoodsByTagAsync({
        type: '4', name: 'recommends', p: 1, pageSize: process.env.VUE_APP_PAGESIZE,
      });
    },
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
};
</script>

<style lang="scss">

</style>
